import * as React from 'react';
import { room } from '../../../../model/room';
import { Grid, withStyles, StyledComponentProps, Divider, Typography } from '@material-ui/core';
import { styles } from './styles';
import { Buttons } from './RoomButtons';
import { contact } from '../../../../model/contact';
import { myroom } from '../../../../model/myroom';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import moment from 'moment';


interface IRoomItemProps extends StyledComponentProps {
    room: room;
    contact: contact;
    updatingRoomsPermissions: boolean;
    addRoom: (sub: string, room: myroom) => any;
    removeRoom: (sub: string, roomId: string) => any;
    updateRoom: (sub: string, room: myroom) => any;
}
interface IRoomItemState {
    dataFine: Date | null;
}

class RoomItem extends React.Component<IRoomItemProps, IRoomItemState> {
    constructor(props) {
        super(props)
        this.state = { dataFine: null }
    }

    componentDidMount() {
        if (this.props.contact.rooms.length > 0) {
            const x = this.props.contact.rooms.find(x => x._id === this.props.room._id);
            if (x && x.endDate) {
                this.setState({ dataFine: x.endDate });
            }
        }
    }

    handleSave() {
        const exists = this.props.contact.rooms.find(x => x._id === this.props.room._id);
        let howtosend: myroom = {
            _id: this.props.room._id,
            description: this.props.room.description,
            endDate: new Date(this.state.dataFine)
        };
        if (exists) {
            this.props.updateRoom(this.props.contact.sub, howtosend)
        } else {
            this.props.addRoom(this.props.contact.sub, howtosend)
        }
    }

    handleDelete() {
        const exists = this.props.contact.rooms.find(x => x._id === this.props.room._id);
        if (exists) {
            this.props.removeRoom(this.props.contact.sub, this.props.room._id)
        }
    }

    handleChangeData(e: Date) {
        this.setState({ dataFine: moment(e).endOf('day').toDate() });
    }

    render() {
        const exists = this.props.contact.rooms.find(x => x._id === this.props.room._id);
        let isExpired = moment(this.state.dataFine).isSameOrBefore(moment());
        return (
            <>
                <Grid container style={{ alignItems: "center" }}>
                    <Grid item xs={1} style={{marginTop: '10px'}} className={this.props.classes.roomDotInfoContainer}>
                        {<div className={isExpired && exists ?
                            this.props.classes.roomExpired :
                            exists ? this.props.classes.roomEnabled : this.props.classes.roomDisabled}></div>}
                    </Grid>
                    <Grid item xs={5} style={{marginTop: '15px'}}>
                        <Typography>{this.props.room.description}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <DatePicker
                            disabled={this.props.updatingRoomsPermissions}
                            key={"date-room-" + this.props.room.description}
                            value={this.state.dataFine}
                            clearable={true}
                            onChange={(e) => { this.handleChangeData(e) }}
                            label="Data Fine Accesso"
                            minDate={new Date()}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Buttons
                            disabled={this.props.updatingRoomsPermissions || this.state.dataFine ? false : true}
                            exist={exists ? true : false}
                            save={() => { this.handleSave(); }}
                            delete={() => { this.handleDelete(); }}
                        />
                    </Grid>

                </Grid>
                <Divider style={{ width: "100%" }} />
            </>
        );
    }
}

export default (withStyles(styles)(RoomItem));